import React from "react";

const Footer = () => (
    <footer className="footer text-center pt-5 pb-3">
        <small>What We Ate || Design by <a className="link--text" href="http://vilawong.net" target="_blank" rel="noopener noreferrer" >Vila Wong</a> &#169; 2020 </small>
    </footer>
)

export default Footer;